import { render, staticRenderFns } from "./WxjkVisitor.vue?vue&type=template&id=afe410a0&scoped=true&"
import script from "./WxjkVisitor.vue?vue&type=script&lang=js&"
export * from "./WxjkVisitor.vue?vue&type=script&lang=js&"
import style0 from "./WxjkVisitor.vue?vue&type=style&index=0&id=afe410a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe410a0",
  null
  
)

export default component.exports